/* Mesmerize · Shop your way · mes-shop-your-way.js (no dependencies)
   Sentence slots, chip tray, card fan, Surprise me, and the CTA link: vibe collection filtered by who + piece, falling
   back to the plain vibe collection when that combination has no products (lazy, cached, debounced check). */
(function () {
  'use strict';
  var SLOTS = ['who', 'vibe', 'piece'];
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var cache = {}; /* filtered URL -> product count (shared by every instance on the page) */

  function init(root) {
    if (root.__msw) return;
    var data; try { data = JSON.parse(root.querySelector('[data-msw-json]').textContent); } catch (e) { return; }
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opts = { who: [], vibe: [], piece: [] };
    data.opts.forEach(function (o) { (opts[o.slot] || opts.piece).push(o); });
    var sel = data.sel, active = data.active, timers = [], checkT = 0;
    var api = root.__msw = {};
    var q = function (s) { return root.querySelector(s); };
    var slotBtn = {}, wordEl = {}, card = {};
    SLOTS.forEach(function (k) {
      slotBtn[k] = q('[data-slot="' + k + '"]');
      wordEl[k] = slotBtn[k] && slotBtn[k].querySelector('[data-word]');
      card[k] = q('[data-card="' + k + '"]');
    });
    var chips = q('[data-chips]'), trayLabel = q('[data-tray-label]'), cta = q('[data-cta]'), ctaText = q('[data-cta-text]');

    function cur(k) { return opts[k][sel[k]]; }
    function enc(v) { return encodeURIComponent(v).replace(/%20/g, '+'); }
    function urlsFor(s, skip) {
      var v = opts.vibe[s.vibe], base = (v && v.url) || data.fallbackUrl, p = [];
      ['who', 'piece', 'vibe'].forEach(function (k) { if (k === skip) return; var o = opts[k][s[k]], name = data.params[k]; if (o && o.filter && name) o.filter.split(',').forEach(function (v) { v = v.trim(); if (v) p.push(name + '=' + enc(v)); }); }); /* several values = match ANY */
      return { base: base, filtered: p.length ? base + (base.indexOf('?') < 0 ? '?' : '&') + p.join('&') : base };
    }
    function urls() { return urlsFor(sel); }
    var pending = {}; /* url -> Promise<count> */
    function count(f) {
      if (f in cache) return Promise.resolve(cache[f]);
      if (pending[f]) return pending[f];
      if (!window.fetch || !data.countSection) return Promise.resolve(1);
      return (pending[f] = fetch(f + (f.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(data.countSection), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
        .then(function (html) { cache[f] = countOf(html); return cache[f]; })
        .catch(function () { return 1; }) /* unknown = keep it visible; never hide on a failed check */
        .then(function (n) { delete pending[f]; return n; }));
    }
    /* Which vibes / pieces have products for the current pick (Priyanka 8 Oct: for him + astro stone should not offer earrings) */
    var avail = { who: [], vibe: [], piece: [] }, availT = 0, availSeq = 0;
    function ok(k, i) { return avail[k][i] !== false; }
    function firstOk(k) { for (var i = 0; i < opts[k].length; i++) if (ok(k, i)) return i; return 0; }
    function refreshAvail() {
      if (!data.hideEmpty || !data.countSection || !window.fetch) return;
      clearTimeout(availT);
      availT = setTimeout(function () {
        var seq = ++availSeq, jobs = [];
        opts.vibe.forEach(function (o, i) {
          var s = { who: sel.who, vibe: i, piece: sel.piece }, u = urlsFor(s, 'piece');
          jobs.push(count(u.filtered).then(function (n) { return ['vibe', i, u.filtered === u.base || n > 0]; }));
        });
        opts.piece.forEach(function (o, i) {
          var u = urlsFor({ who: sel.who, vibe: sel.vibe, piece: i });
          jobs.push(count(u.filtered).then(function (n) { return ['piece', i, u.filtered === u.base || n > 0]; }));
        });
        Promise.all(jobs).then(function (res) {
          if (seq !== availSeq) return;
          var next = { who: [], vibe: [], piece: [] };
          res.forEach(function (r) { next[r[0]][r[1]] = r[2]; });
          ['vibe', 'piece'].forEach(function (k) { if (!next[k].some(Boolean)) next[k] = []; }); /* never hide everything */
          avail = next;
          var moved = false;
          ['vibe', 'piece'].forEach(function (k) { if (!ok(k, sel[k])) { sel[k] = firstOk(k); moved = true; } });
          render(false); if (moved) { animate('vibe'); animate('piece'); refreshAvail(); }
        });
      }, 200);
    }
    function countOf(html) {
      var m = /data-msw-count="(\d+)"/.exec(html) || /data-mhc-count[^>]*>\s*(\d+)/.exec(html);
      if (m) return +m[1];
      return /\/products\//.test(html) ? 1 : 0; /* no count marker: zero when no product links came back */
    }
    function applyCta() {
      if (!cta) return;
      var u = urls();
      cta.href = cache[u.filtered] === 0 ? u.base : u.filtered;
      if (!data.check || !data.countSection || u.filtered === u.base || u.filtered in cache) return;
      clearTimeout(checkT);
      checkT = setTimeout(function () {
        var f = u.filtered;
        if (f in cache || !window.fetch) return;
        fetch(f + '&section_id=' + encodeURIComponent(data.countSection), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
          .then(function (html) { cache[f] = countOf(html); if (urls().filtered === f) applyCta(); })
          .catch(function () { /* keep the filtered URL; never block the click */ });
      }, 250);
    }
    function ctaLabel() {
      return data.cta.replace(/\{(who|vibe|piece)\}/g, function (_, k) { var o = cur(k); return o ? o.cta : ''; });
    }
    function chip(o, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'msw__chip'; b.setAttribute('data-i', i); b.textContent = o.chip;
      return b;
    }
    function render(trayChanged) {
      SLOTS.forEach(function (k) {
        var o = cur(k), on = k === active;
        if (slotBtn[k]) { slotBtn[k].classList.toggle('is-active', on); slotBtn[k].setAttribute('aria-pressed', on ? 'true' : 'false'); }
        if (wordEl[k] && o && wordEl[k].textContent !== o.word) wordEl[k].textContent = o.word;
        var c = card[k]; if (!c || !o) return;
        c.classList.toggle('is-active', on);
        c.href = o.url || data.fallbackUrl;
        c.setAttribute('aria-label', (data.cardPrefix ? data.cardPrefix + ' ' : '') + o.chip);
        var img = c.querySelector('.msw__img'), tag = c.querySelector('[data-tag]');
        if (tag && tag.textContent !== o.tag) tag.textContent = o.tag;
        if (img) {
          if (o.img) {
            if (img.getAttribute('src') !== o.img) { if (o.srcset) { img.srcset = o.srcset; } else { img.removeAttribute('srcset'); } img.src = o.img; }  /* srcset first, so the browser fetches only the size it needs */
            img.alt = o.chip; img.hidden = false;
          } else { img.hidden = true; img.removeAttribute('src'); img.removeAttribute('srcset'); }
        }
      });
      if (chips) {
        if (trayChanged) {
          chips.textContent = '';
          opts[active].forEach(function (o, i) { chips.appendChild(chip(o, i)); });
          if (trayLabel) trayLabel.textContent = data.labels[active] || '';
        }
        Array.prototype.forEach.call(chips.children, function (b, i) { b.setAttribute('aria-pressed', i === sel[active] ? 'true' : 'false'); b.hidden = !ok(active, i); });
      }
      if (ctaText) ctaText.textContent = ctaLabel();
      applyCta();
    }
    function animate(k) {
      if (reduce) return;
      var w = wordEl[k];
      if (w && w.animate) w.animate([{ transform: 'translateY(105%)', opacity: 0 }, { transform: 'translateY(-8%)', opacity: 1, offset: .7 }, { transform: 'translateY(0)' }], { duration: 420, easing: EASE });
      var c = card[k] && card[k].querySelector('[data-sbi]');
      if (c && c.animate) c.animate([{ transform: 'rotateY(90deg) scale(.96)' }, { transform: 'rotateY(0deg) scale(1)' }], { duration: 520, easing: EASE });
    }
    function activate(k) { var ch = k !== active; active = k; render(ch); }
    function set(k, i, roll, step) {
      var n = opts[k].length; if (!n) return;
      i = ((i % n) + n) % n;
      for (var g = 0; step && g < n && !ok(k, i); g++) i = (i + step + n) % n; /* skip hidden choices */
      if (i === sel[k] && !roll) { activate(k); return; }
      var ch = k !== active; sel[k] = i; active = k; render(ch); animate(k);
      if (k !== 'piece') refreshAvail();
    }
    function randomOk(k) { var c = []; opts[k].forEach(function (o, i) { if (ok(k, i)) c.push(i); }); return c.length ? c[Math.floor(Math.random() * c.length)] : 0; }
    function onClick(e) {
      var t = e.target.closest('[data-slot],[data-i],[data-surprise]'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-slot')) {
        var k = t.getAttribute('data-slot');
        if (k === active) set(k, sel[k] + 1, false, 1); else activate(k);
      } else if (t.hasAttribute('data-i')) {
        set(active, +t.getAttribute('data-i'));
      } else {
        SLOTS.forEach(function (k, j) {
          timers.push(setTimeout(function () { set(k, randomOk(k), true); }, j * 140)); /* pieces re-check after who/vibe land */
        });
      }
    }
    root.addEventListener('click', onClick);

    api.selectBlock = function (id) {
      SLOTS.forEach(function (k) { opts[k].forEach(function (o, i) { if (o.id === id) set(k, i); }); });
    };
    api.destroy = function () { root.removeEventListener('click', onClick); timers.forEach(clearTimeout); clearTimeout(checkT); root.__msw = null; };
    applyCta(); refreshAvail();
  }

  function start(scope) {
    var roots = (scope || document).querySelectorAll('.msw');
    Array.prototype.forEach.call(roots, function (r) {
      if (r.__msw || r.__mswW) return;
      if (!window.IntersectionObserver) { init(r); return; }
      r.__mswW = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        r.__mswW.disconnect(); r.__mswW = null; init(r);
      }, { rootMargin: '200px 0px' });
      r.__mswW.observe(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.msw'), function (r) {
      if (r.__mswW) { r.__mswW.disconnect(); r.__mswW = null; }
      if (r.__msw && r.__msw.destroy) r.__msw.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var r = e.target.closest && e.target.closest('.msw'); if (!r) return;
    if (!r.__msw) { if (r.__mswW) { r.__mswW.disconnect(); r.__mswW = null; } init(r); }
    if (r.__msw && r.__msw.selectBlock && e.detail) r.__msw.selectBlock(e.detail.blockId);
  });
})();
